<template>
  <tr class="mtable-tr">
    <td
      class="mtable-td"
      v-for="(td, index) in cols"
      :key="index"
      :class="line ? 'mtable-line' : ''"
    >
      <template v-if="td.label == 'index'">
        {{ myindex }}
      </template>
      <template v-else-if="td.islink">
        <router-link
          target="_blank"
          class="goLink"
          :to="{ name: 'Search', params: { q: data[td.field] } }"
          >{{ data[td.field] }}
        </router-link>
      </template>
      <template v-else>{{ data[td.field] }}</template>
    </td>
  </tr>
</template>

<script>
export default {
  name: "TableTr",
  props: {
    myindex: {
      type: Number,
      default: 0,
    },
    data: {
      type: Object,
      default: () => {},
    },
    cols: {
      type: Array,
      default: () => [],
    },
    line: {
      type: Boolean,
      default: true,
    },
  },
  created() {},
};
</script>

<style lang="less" scoped>
.mtable-tr {
  cursor: default;
  transition: none;
  border-top: solid 1px #00000040;
  &:hover {
    background: #5932ea90 !important;
    color: #fff;
  }
  .mtable-td {
    transition: none;
    padding: 0.5rem;
  }
  .mtable-line {
    border: solid 1px #00000040;
  }
  .goLink {
    &:hover {
      color: #fff;
    }
  }
}
</style>
